import {useCallback, useEffect, useRef, useState} from 'react'

import {uuid} from '@/src/shared/utils/functions'

export const useCaptcha = () => {
  const [visibleCaptcha, setVisibleCaptcha] = useState(true)
  const [token, setToken] = useState<string | null>(null)
  const [renderKey, setRenderKey] = useState(() => uuid())
  const tokenRef = useRef(token)

  const reset = useCallback(() => {
    setToken(null)
    setRenderKey(uuid())
  }, [])

  const onSuccessToken = useCallback((token: string) => {
    setToken(token)
  }, [])

  useEffect(() => {
    tokenRef.current = token
  }, [token])

  return {
    visibleCaptcha,
    setVisibleCaptcha,
    token,
    onSuccessToken,
    renderKey,
    reset,
  }
}
